import IdqsOrderPage from './IdqsOrderPage';
export { IdqsOrderPage };
export default IdqsOrderPage;
